import { render, staticRenderFns } from "./PanelContextMenu.vue?vue&type=template&id=7aa27e56&scoped=true&"
import script from "./PanelContextMenu.vue?vue&type=script&lang=js&"
export * from "./PanelContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./PanelContextMenu.vue?vue&type=style&index=0&id=7aa27e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa27e56",
  null
  
)

export default component.exports